<!--
 * @Description: 
 * @Version: 2.0
 * @Author: Zed
 * @Date: 2020-10-10 13:47:16
 * @LastEditors: Zed
 * @LastEditTime: 2020-10-13 11:12:45
-->
<template>
  <el-table
    :data="list"
    :show-header="!hideHeader"
    style="width: 100%"
    @row-click="onInfo"
  >
    <el-table-column :show-overflow-tooltip="true" label="公告名称" prop="projectName">
      <template slot-scope="scope">
        <!-- <a href="javascript:;" :class="scope.row.signType==2?'sucess':'info'">{{scope.row.projectName}}</a> -->
        <a href="javascript:;" class="sucess">{{ scope.row.title }}</a>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      label="发布日期"
      prop="createTime"
      width="180"
    >
      <template slot-scope="scope">
        <div class="release-time" style="cursor: pointer; width: 100%">
          {{ scope.row.createTime }}
        </div>
      </template>
    </el-table-column>
    <el-table-column v-if="false" :show-overflow-tooltip="true" prop="status" width="100">
      <template slot-scope="scope">
        <el-button
          :type="scope.row.signType == 2 ? 'primary' : ''"
          :disabled="scope.row.signType == 1 || scope.row.signType == 3"
          size="mini"
          plain
          >{{ scope.row.signTypeName }}</el-button
        >
      </template>
    </el-table-column>
    <div slot="empty" class="empty">
      <el-empty description="暂无数据" />
    </div>
  </el-table>
</template>

<script>
export default {
  props: {
    list: Array,
    hideHeader: Boolean,
  },
  methods: {
    onInfo(row) {
      // console.log("ddddddddddddddd", row);
      // sessionStorage.setItem("projectId",row.projectId );
      // sessionStorage.setItem("bulletinId",row.id);
      this.$router.push({
        path: "/purchase/info",
        query: {
          noticeId: row.noticeId,
          projectId: row.projectId,
          type: 2,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
  tr {
    cursor: pointer;
  }
}
.el-table tr {
  background-color: #fff !important;
  cursor: pointer !important;
}

.info {
  color: #c0c4cc;
  text-decoration: none;
}
.sucess {
  color: #131313;
  text-decoration: none;
}
</style>
